import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Services, ServicesArray} from '../../../../../model/services';
import {ActivatedRoute, Router} from '@angular/router';
import {TextsComponent} from '../../../../elements/texts/texts.component';
import {MenuService} from '../../../../../services/menu-services';
import {FeedbackService} from '../../../../../services/feedback-service';
import {scrollUp} from '../../../../../functions/scroll-up';
import {ScrollService} from '../../../../../services/scroll-service';

@Component({
  selector: 'app-mob-service-page',
  imports: [
    TextsComponent
  ],
  templateUrl: './mob-service-page.component.html',
  styleUrl: './mob-service-page.component.scss'
})
export class MobServicePageComponent implements OnInit, OnDestroy{
  constructor(private route: ActivatedRoute,
              protected menuService: MenuService,
              public feedValue: FeedbackService,
              private router: Router,
              public scrollService: ScrollService) {}

  location: Services = new Services();

  ngOnInit() {
    this.scrollService.lockScroll();
    this.menuService.setMobileStyle('transparent');
    this.setData();
  }

  ngOnDestroy() {
    this.menuService.setMobileStyle('white');
    this.scrollService.unlockScroll();
  }

  setData() {
    const url = this.route.snapshot.paramMap.get('service') ?? 'add';
    const service = ServicesArray.find(item => {
      if (!item.title || item.title.length === 0) {
        return false;
      }
      const textObj = item.title[0];
      if (!textObj || !textObj.text || textObj.text.length < 2) {
        return false;
      }
      const englishName = textObj.text[1];
      if (!englishName || typeof englishName !== 'string') {
        return false;
      }
      const normalizedName = englishName.toLowerCase().replace(/\s+/g, '_');
      return normalizedName === url;
    });

    if (service) {
      this.location = service;
    }
  }

  get backgroundFilter(): string {
    let filterValue = 'brightness(0.8)';
    if (this.location.filter !== undefined) {
      if (this.location.filterNumber === undefined) {
        filterValue += ' grayscale(100%)';
      } else {
        filterValue += ` grayscale(${this.location.filterNumber}%)`;
      }
    }
    return filterValue;
  }

  getSubtitle(type: 'eng' | 'rus') {
    switch (type) {
      case 'rus': {
        return this.location?.subtitle?.[0] || '';
      }
      case 'eng': {
        return this.location?.subtitle?.[1] || '';
      }
    }
  }

  onClick() {
    scrollUp();
    this.feedValue.setFeedbackValue(this.location.feedValue ?? []);
    this.router.navigate([ '/feedback' ]).then(r => r)
  }
}
